import ProjectLogisticsInfo from './ProjectLogisticsInfo';
export default ProjectLogisticsInfo;